/**
 * Scrolls an input field into view above the keyboard
 * Shows the field's label and centers it in the visible space
 * 
 * @param element - The input/textarea element that received focus
 * @param options - Optional configuration
 */
export const scrollFieldIntoView = (
  element: HTMLInputElement | HTMLTextAreaElement,
  options: {
    delay?: number;
    offset?: number;
    selectText?: boolean;
  } = {}
) => {
  const { delay = 300, offset = -80, selectText = false } = options;

  if (selectText) {
    element.select();
  }

  setTimeout(() => {
    // Scroll the parent element (which includes the label) to the top
    element.parentElement?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    
    // Then scroll up by offset to center in visible space above keyboard
    setTimeout(() => {
      window.scrollBy({ top: offset, behavior: 'smooth' });
    }, 100);
  }, delay);
};
